const THIRTY_MINUTES_MS = 30 * 60 * 1000;

// Client onboarding (payment -> store connect -> data sync) isn't actually done the instant
// sw_store_sync_flag flips true - that flag is set the moment the sync job is ENQUEUED
// (store-sync.js), not when it finishes, and there's no real "sync complete" signal from the job
// today. A fixed grace window since store_sync_started_at stands in for "still syncing": a
// re-login during that window must land back on the sign-up wizard's syncing step, not skip past
// it to business onboarding / the main app.
export const hasPendingClientOnboarding = (user) => {
  const { sw_payment_flag, sw_store_flag, sw_store_sync_flag, store_sync_started_at } = user || {};
  if (!sw_payment_flag || !sw_store_flag || !sw_store_sync_flag) return true;
  const startedAt = new Date(store_sync_started_at).getTime();
  return startedAt > Date.now() - THIRTY_MINUTES_MS;
};

// Which onboarding wizard step (1-5) the account's real progress indicates, independent of
// whatever's cached in localStorage - localStorage alone is unreliable across browsers/devices
// or a cleared cache, and can leave a re-logging-in user stuck on step 1 despite having finished
// steps 3-4 already. Steps 1-2 (user info, email verification) aren't tracked by any server flag;
// callers should only trust this once they know the account is actually confirmed/logged in
// (otherwise a brand-new, mid-signup user with no flags set yet would get bounced to step 3).
// Returns null when the account isn't ahead of anything localStorage would already show.
export const getServerOnboardingStep = (user) => {
  const { sw_payment_flag, sw_store_flag, sw_store_sync_flag, store_sync_started_at } = user || {};
  if (!sw_payment_flag) return 3;
  if (!sw_store_flag) return 4;
  if (!sw_store_sync_flag) return 4;
  const startedAt = new Date(store_sync_started_at).getTime();
  if (startedAt > Date.now() - THIRTY_MINUTES_MS) return 5;
  return null; // sync flagged done and past the grace window - not the wizard's concern anymore
};
